module.exports = __webpack_public_path__ + "media/images/gallery/solar_systems/craters_on-2996fac70b684bf62ad16784e6e72502.gif";